if (!customElements.get('stock-enquiry')) {
  customElements.define('stock-enquiry', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;

      this.buyButtons = this.parentElement.querySelector(
        'product-form .product-form__buttons'
      );
      this.originalDisplay = this.buyButtons?.style.display || '';

      this.setVisible(this.dataset.soldOut === 'true');

      this.unsubscribeOptions = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        ({ data }) => {
          if (!this.productInfo.contains(data.event.target)) return;
          this.setVisible(false);
        }
      );

      this.unsubscribeVariant = subscribe(
        PUB_SUB_EVENTS.variantChange,
        ({ data }) => {
          const sectionId =
            this.productInfo.dataset.originalSection ||
            this.productInfo.dataset.section;

          if (String(data.sectionId) !== String(sectionId)) return;

          const source = Array.from(
            data.html.querySelectorAll('stock-enquiry')
          ).find(element =>
            element.dataset.sectionId === String(data.sectionId)
          );

          if (!source || !data.variant) {
            this.setVisible(false);
            return;
          }

          this.dataset.product = source.dataset.product;
          this.dataset.variant = data.variant.title;
          this.dataset.variantId = String(data.variant.id);
          this.dataset.productUrl = source.dataset.productUrl;
          this.dataset.soldOut = String(data.variant.available === false);

          this.updateFields();
          this.setVisible(data.variant.available === false);
        }
      );

      this.preventHiddenSubmission = event => {
        if (this.hidden) event.preventDefault();
      };

      this.querySelector('form')?.addEventListener(
        'submit', this.preventHiddenSubmission
      );
    }

    disconnectedCallback() {
      this.unsubscribeOptions?.();
      this.unsubscribeVariant?.();

      this.querySelector('form')?.removeEventListener(
        'submit', this.preventHiddenSubmission
      );
    }

    setVisible(visible) {
      this.hidden = !visible;

      if (this.buyButtons) {
        this.buyButtons.style.display =
          visible ? 'none' : this.originalDisplay;
      }

      if (!visible) {
        this.querySelector('details')?.removeAttribute('open');
      }
    }

    updateFields() {
      this.querySelector('[data-enquiry-product]').value =
        this.dataset.product;

      this.querySelector('[data-enquiry-variant]').value =
        this.dataset.variant;

      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', this.dataset.variantId);

      this.querySelector('[data-enquiry-url]').value = url.toString();

      this.querySelector('[data-enquiry-description]').textContent =
        `${this.dataset.product} — ${this.dataset.variant}`;
    }
  });
}